export function decodeBase64(base64Encoded: string) {
  const decoded = window.atob(
    String(base64Encoded.replace(/[\t\n\f\r ]+/g, ""))
  );
  const buffer = Uint8Array.from(decoded, (c) => c.charCodeAt(0));
  return buffer;
}
